import { Stack } from '@jarvis/web-stratus-client';
import { JarvisAuthProvider } from '@jarvis/web-http';
import { CurrentUsageData, UsageData } from 'src/types/usage';
import axios, { AxiosInstance } from 'axios';
import environments from '../configs/environment.json';

class UsageClient {
  httpClient: AxiosInstance;
  mfeAuthProvider: JarvisAuthProvider;
  bLId: string;
  baseUrl: string;

  constructor(authProvider: JarvisAuthProvider, stack: Stack) {
    this.httpClient = axios;
    this.mfeAuthProvider = authProvider;
    type EnvKey = keyof typeof environments;
    const envKeys = Object.keys(environments) as EnvKey[];
    const currentEnv = environments[envKeys[stack]];
    this.baseUrl =
      currentEnv?.variables?.MBLC_BASE_URL ||
      'https://pie-us1.api.ws-hp.com/masterblcontroller/v1';
    this.bLId = currentEnv?.variables?.BL_ID;
  }

  async getUsageByBillingId(
    subscriptionId: string,
    entityId: string,
    billingCycleId: string
  ): Promise<CurrentUsageData> {
    const stratusToken = await this.mfeAuthProvider.getAccessToken();
    const headers = {
      accept: 'application/json',
      authorization: `Bearer ${stratusToken}`
    };

    const response = await this.httpClient.get(
      `${this.baseUrl}/${this.bLId}/usage/${subscriptionId}/${entityId}/billingcycle/${billingCycleId}`,
      { headers }
    );

    return response.data;
  }

  async getAllUsageData(
    subscriptionId: string,
    entityId: string
  ): Promise<UsageData[]> {
    const stratusToken = await this.mfeAuthProvider.getAccessToken();
    const headers = {
      accept: 'application/json',
      authorization: `Bearer ${stratusToken}`
    };

    let returnData: UsageData[] = [];
    const nextPage = '';
    console.log('bizlogic', this.bLId);

    const response = await this.httpClient.get(
      nextPage
        ? nextPage
        : `${this.baseUrl}/${this.bLId}/usage/${subscriptionId}/${entityId}`,
      {
        headers,
        params: {
          refresh: true,
          limit: 20
        }
      }
    );

    returnData = [...returnData, response.data];

    return returnData;
  }
}

export default UsageClient;
